import { useNavigate } from 'react-router-dom';

/**
 * useMobileSettingsNavigation - Custom hook for mobile settings navigation
 * Centralized navigation logic to improve DRY principles
 */
export const useMobileSettingsNavigation = () => {
  const navigate = useNavigate();

  const handleBackSettings = () => {
    navigate('/settings');
  };

  const handleBackToHome = () => {
    navigate('/mobile-demo');
  };

  return {
    handleBackSettings,
    handleBackToHome,
    navigate,
  };
};
